import React from "react";
import { Heart, Users, BookOpen, Home, Gift, Star } from "lucide-react";
import { Link } from "react-router-dom";

const SponsorChild = () => {
  const sponsorshipCards = [
    {
      id: 1,
      title: "শিক্ষা সহায়তা",
      description: "একটি শিশুর শিক্ষার জন্য মাসিক সহায়তা প্রদান",
      amount: "১৫০০/-",
      period: "মাসিক",
      icon: BookOpen,
      gradient: "from-blue-500 to-cyan-500",
      features: ["বই-খাতা", "স্কুল ফি", "ইউনিফর্ম"],
    },
    {
      id: 2,
      title: "খাদ্য সহায়তা",
      description: "পুষ্টিকর খাবারের জন্য নিয়মিত সাহায্য",
      amount: "২০০০/-",
      period: "মাসিক",
      icon: Heart,
      gradient: "from-pink-500 to-rose-500",
      features: ["দৈনিক খাবার", "পুষ্টি সাপ্লিমেন্ট", "বিশুদ্ধ পানি"],
    },
    {
      id: 3,
      title: "চিকিৎসা সেবা",
      description: "স্বাস্থ্যসেবা ও চিকিৎসার জন্য সহায়তা",
      amount: "১০০০/-",
      period: "মাসিক",
      icon: Users,
      gradient: "from-green-500 to-emerald-500",
      features: ["নিয়মিত চেকআপ", "ওষুধপত্র", "জরুরি চিকিৎসা"],
    },
    {
      id: 4,
      title: "পূর্ণাঙ্গ পৃষ্ঠপোষকতা",
      description: "একটি শিশুর সম্পূর্ণ দায়িত্ব গ্রহণ",
      amount: "৫০০০/-",
      period: "মাসিক",
      icon: Home,
      gradient: "from-purple-500 to-indigo-500",
      features: ["শিক্ষা", "খাদ্য", "বাসস্থান", "চিকিৎসা"],
    },
  ];

  return (
    <div className="container mx-auto px-4 py-12">
      {/* Header Section */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
          <Gift className="w-8 h-8 text-primary" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          একটি শিশুর স্বপ্ন পূরণে আপনিও অংশীদার হন
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto text-lg">
          আপনার দানের মাধ্যমে একটি শিশুর জীবন পরিবর্তন করুন
        </p>
      </div>

      {/* Sponsorship Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {sponsorshipCards.map((card) => {
          const IconComponent = card.icon;
          return (
            <div
              key={card.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden group flex flex-col h-full"
            >
              {/* Card Header with Gradient */}
              <div
                className={`bg-gradient-to-r ${card.gradient} p-6 text-white relative overflow-hidden`}
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-full -translate-y-10 translate-x-10"></div>
                <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/10 rounded-full translate-y-8 -translate-x-8"></div>
                <div className="relative z-10">
                  <IconComponent className="w-12 h-12 mb-4" />
                  <h3 className="text-xl font-bold mb-2">{card.title}</h3>
                  <p className="text-white/90 text-sm">{card.description}</p>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-6 flex flex-col flex-grow">
                {/* Price */}
                <div className="text-center mb-4">
                  <div className="text-3xl font-bold text-primary mb-1">
                    {card.amount}
                  </div>
                  <div className="text-sm text-gray-500">{card.period}</div>
                </div>

                {/* Features */}
                <div className="space-y-2 mb-6 flex-grow">
                  {card.features.map((feature, index) => (
                    <div
                      key={index}
                      className="flex items-center text-sm text-gray-600"
                    >
                      <Star className="w-4 h-4 text-primary mr-2 fill-current" />
                      {feature}
                    </div>
                  ))}
                </div>

                {/* Sponsor Button - Always at bottom */}
                <div className="mt-auto">
                  <button className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200 group-hover:scale-105 transform">
                    পৃষ্ঠপোষক হন
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Impact Stats */}
      <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-2xl p-8 mb-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-primary mb-2">২৫০+</div>
            <div className="text-gray-600">সহায়তাপ্রাপ্ত শিশু</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-primary mb-2">৯৮%</div>
            <div className="text-gray-600">শিক্ষা সফলতার হার</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-primary mb-2">৫০+</div>
            <div className="text-gray-600">সক্রিয় পৃষ্ঠপোষক</div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto border border-gray-100">
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
              <Heart className="w-8 h-8 text-primary fill-current" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              আজই একটি শিশুর জীবনে পরিবর্তন আনুন
            </h3>
            <p className="text-gray-600 mb-6">
              আপনার ছোট্ট একটি দান একটি শিশুর পুরো ভবিষ্যৎ পাল্টে দিতে পারে।
              আমাদের সাথে যুক্ত হয়ে সমাজের কল্যাণে এগিয়ে আসুন।
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={"/donation"}
              className="bg-primary hover:bg-primary/90 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 inline-flex items-center justify-center"
            >
              <Gift className="w-5 h-5 mr-2" />
              এখনই দান করুন
            </Link>
            <Link
              to={"/about"}
              className="border border-primary text-primary hover:bg-primary hover:text-white font-semibold py-4 px-8 rounded-lg transition-all duration-200 transform hover:scale-105"
            >
              আরও জানুন
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorChild;
